// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__36hBk","buttons":"Footer_buttons__1HZ7Q"};